import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Rentals. /club/rentals. Reservation → out → returned lifecycle.
//   {id}: { memberId, itemType, status, outDate, dueDate, returned,
//           returnedDate, damage, fees, notes, createdAt }
const BASE = 'club/rentals'
export const RENTAL_ITEMS = ['Rental Set', 'Push Cart', 'Electric Cart', 'Pull Cart', 'GPS', 'Rangefinder', 'Umbrella', 'Speaker']
export const RENTAL_STATUSES = ['Reserved', 'Out', 'Returned']
const today = () => new Date().toISOString().slice(0, 10)
const num = (v) => (v === '' || v == null ? 0 : Number(v) || 0)

export function watchRentals(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }

export async function createRental(d, asReservation) {
  const itemType = d.itemType || RENTAL_ITEMS[0]
  const node = push(tref(BASE))
  const status = asReservation ? 'Reserved' : 'Out'
  await set(node, {
    id: node.key, memberId: d.memberId || null, itemType, status,
    outDate: asReservation ? '' : (d.outDate || today()),
    dueDate: d.dueDate || '', returned: false, returnedDate: '',
    damage: '', fees: num(d.fees), notes: String(d.notes || '').trim(), createdAt: Date.now(),
  })
  logActivity({ type: 'rental', memberId: d.memberId || null, icon: '🛍️', text: `${itemType} ${asReservation ? 'reserved' : 'out'}` })
  return node.key
}

export async function checkOutRental(id, itemType) {
  await update(tref(`${BASE}/${id}`), { status: 'Out', outDate: today() })
  logActivity({ type: 'rental', icon: '🛍️', text: `${itemType || 'Rental'} checked out` })
}

export async function returnRental(id, { damage, fees }, memberId, itemType) {
  await update(tref(`${BASE}/${id}`), { status: 'Returned', returned: true, returnedDate: today(), damage: String(damage || '').trim(), fees: num(fees) })
  logActivity({ type: 'rental', memberId: memberId || null, icon: '🛍️', text: `${itemType || 'Rental'} returned` })
}

export async function updateRental(id, patch) {
  const clean = {}
  for (const k of ['itemType', 'outDate', 'dueDate', 'damage', 'notes']) if (patch[k] != null) clean[k] = String(patch[k]).trim()
  if (patch.memberId !== undefined) clean.memberId = patch.memberId || null
  if (patch.fees !== undefined) clean.fees = num(patch.fees)
  await update(tref(`${BASE}/${id}`), clean)
}

export async function deleteRental(id) { await remove(tref(`${BASE}/${id}`)) }
export const isRentalOverdue = (r) => r.status === 'Out' && r.dueDate && r.dueDate < today()
